import React, {ComponentType} from "react";
import {Box, Heading, Icon} from "@unibuddy/patron";

type SelectedMenuItemProps = {
    icon: ComponentType<React.ReactNode>;
    text: string;
    color: string;
};

const SelectedMenuItem: React.FC<SelectedMenuItemProps> = ({icon, text, color}) => (
    <Box display="flex" alignItems="center" gap="xxsmall">
        <Icon icon={icon} size="medium" color={color} />
        <Heading level="2" size="xsmall" color={color} weight="600">
            {text}
        </Heading>
    </Box>
);

export default SelectedMenuItem;
